/**
 * Gen1TrunkingOrderLicenseKeyFiles テーブル用 ViewModel
 * API レスポンスのマッピング用。
 */
export default class {
    constructor(dataObject = null) {
        this.id = 0;
        this.Gen1TrunkingOrderHeaderId = 0;
        this.FileName = '';
        this.StorageContainerName = '';
        this.StorageBlobPath = '';
        this.UploadedDate = null; // Date | null
        this.UploadedByUser = '';

        if (dataObject) {
            try {
                this.id = dataObject.id ?? 0;
                this.Gen1TrunkingOrderHeaderId =
                    dataObject.Gen1TrunkingOrderHeaderId ?? 0;
                this.FileName = dataObject.FileName ?? '';
                this.StorageContainerName =
                    dataObject.StorageContainerName ?? '';
                this.StorageBlobPath = dataObject.StorageBlobPath ?? '';

                const uploadedSrc = dataObject.UploadedDate ?? null;
                this.UploadedDate = uploadedSrc ? new Date(uploadedSrc) : null;

                this.UploadedByUser = dataObject.UploadedByUser ?? '';
            } catch (e) {
                throw new Error(
                    'Data import error @ Gen1TrunkingOrderLicenseKeyFile.'
                );
            }
        }
    }
}
